<script setup lang="ts">
import type { GenericParameters } from "~/core/models/GenericParameters.type";
import type { UseFetchResponse } from "~/core/models/UseFetchResponse.interface";
import { OrganizationType } from "~/modules/organization/models/OrganizationType.enum";
import type { RelationEntity } from "~/modules/relation/models/RelationEntity.interface";

const props = defineProps<
  GenericParameters & {
    organizationType?: OrganizationType;
    fetchGivenDelegationResponse?: UseFetchResponse<RelationEntity>;
    fetchReceivedDelegationResponse?: UseFetchResponse<RelationEntity>;
  }
>();
</script>

<template>
  <relations-container>
    <h4 class="mb-5 text-gray-900">
      {{ $t("administration.relations.delegations.title") }}
    </h4>

    <delegation-received-list
      v-if="
        organizationCode === undefined ||
        organizationType === OrganizationType.ADMINISTRATION
      "
      v-bind="props"
    />

    <delegation-given-list
      v-else-if="organizationType === OrganizationType.OPERATOR"
      v-bind="props"
    />
  </relations-container>
</template>
